import { Injectable } from '@angular/core';
import {FidjiDocumentWebService, IMDocument, IMDocumentsList, IMPublication} from '@immanens-com/fidji-api-module';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {Observable} from 'rxjs/Observable';
import {UserControllerService} from '../user/user-controller.service';
import {combineLatest} from 'rxjs/observable/combineLatest';

@Injectable()
export class DocumentControllerService {

  private allDocumentsSubject = new BehaviorSubject<IMDocument[]>([]);

  private userDocumentsSubject = new BehaviorSubject<IMDocument[]>([]);

  private userDownloadedDocumentsSubject = new BehaviorSubject<IMDocument[]>([]);
  public userDownloadedDocumentsChange = this.userDownloadedDocumentsSubject.asObservable();

  constructor(private documentWS: FidjiDocumentWebService, private userCtrl: UserControllerService) {}

  public loadUserDocuments(): void {
    this.documentWS.getUserDocumentList().subscribe((list) => {
      this.userDocumentsSubject.next(list.models);
      this.allDocumentsSubject.next(list.models);
    });
  }

  public documentsByPublication(dly_pub_id: string): Observable<IMDocument[]> {
    return this.allDocumentsSubject.map((docList) => docList.filter((doc) => doc.dly_pub_id === dly_pub_id));
  }

  // States for documents view
  public haveBeenDownloadedBefore(dly_doc_id: number): Observable<boolean> {
    return this
      .userDownloadedDocumentsSubject
      .map((docList) => docList.findIndex(doc => doc.dly_doc_id === dly_doc_id) !== -1)
      .map(present => this.userCtrl.isLogged && present);
  }

  public isInUserOffer(dly_doc_id: number): Observable<boolean> {
    return this
      .userDocumentsSubject
      .map((docList) => docList.findIndex(doc => doc.dly_doc_id === dly_doc_id) !== -1)
      .map(present => this.userCtrl.isLogged && present);
  }

}



// WEBPACK FOOTER //
// ./src/app/core/services/document/document-controller.service.ts